
<script setup>

	import {reactive, ref} from "vue";

	import { useStore } from 'vuex'
	import { useRouter } from 'vue-router'


	import authService from "@/services/authService.js";

	import Modal from "@/components/Modal.vue";
	
	let userData = reactive({username: "", password: "", newPassword: ""});
	// NONE, NEW_PASSWORD_REQUIRED
	let loginState = ref("NONE");
	let error = ref("x");
	let passError = ref(false);

	let store = useStore();
	let router = useRouter();

	async function authenticate(){
		try{

			let authResult = await authService.attemptAuth(userData.username, userData.password);
			
			if (authResult.success == false){
				loginState.value = authResult.challenge;
				userData.session = authResult.session;
			}else{
				store.commit("userToken", authResult.token);
				store.commit("userName", userData.username);
				router.push({name: "AdminWalls"});
			}

			error.value = false;
		}catch(e){
			if(e.name){
				error.value = e.message;
			}else{
				console.log(e);
			}
		}
	}



	async function newPassword(){
		try{
			let authResult = await authService.newPassword(userData.username, userData.newPassword, userData.session);

			if (authResult.success == true){
				store.commit("userToken", authResult.token);
				store.commit("userName", userData.username);
				router.push({name: "AdminWalls"});
			}
		}catch(e){
			if(e.name){
				passError.value = e.message;
			}else{
				console.log(e);
			}
		}
	}
	</script>

<template>
	<Modal>
		<div v-if="loginState === 'NONE'">
			<form v-on:submit.prevent="authenticate">
				<h2>Please Log In - {{loginState}}</h2>
				<div class="login-error" :class="{visible: error!='x'}">{{error}}</div>
				<div>Username: <input v-model="userData.username"/></div>
				<div>Password: <input v-model="userData.password" type="password"/></div>
				<button type="submit">Login</button>
				<div><router-link to="/signup">Or click here to sign up instead</router-link></div>

			</form>
		</div>
		<div v-if="loginState === 'NEW_PASSWORD_REQUIRED'">
			<form v-on:submit.prevent="newPassword">
				<h2>Choose New Password</h2>
				<br/>
				<div>New Password: <input v-model="userData.newPassword" type="password" /></div>
				<div v-if="passError">{{passError}}</div>
				<button type="submit">Login</button>
			</form>
		</div>
	</Modal>
</template>


<style scoped>
.login-error {
	color: red;
	font-weight: bolder;
	opacity: 0;
}

.visible{
	transition: opacity 1s;
	opacity: 1;
}
</style>